import React, { Component } from 'react';
import styled from 'styled-components';

import { Font } from '../../utils/fonts';
import color from '../../utils/colors';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';

import AnimationContainer from '../FadeAnimation';
import Content from '../Content';
import Filters from '../MenuFilters';
import CaseWithSlider from '../CaseWithSlider';
import CaseWithResize from '../CaseWithResize';
import BorderButton from '../BorderButton';
import PopupWithImages from './PopupWithImages';

export default class Decisions extends Component {
    constructor(props) {
        super(props);

        this.handleOpenFullSizeImages = this.handleOpenFullSizeImages.bind(this);
    }

    handleOpenFullSizeImages(slides = [''], uuid, callbackClose, currentIndex) {
        const { handleOpenPopUp } = this.props;

        handleOpenPopUp(PopupWithImages, {
            slides,
            uuid,
            callbackClose,
            currentIndex,
        }, true);
    }

    render() {
        const {
            className,
            decisions,
            filters,
            moreDownloadNum,
            onMoreDownloadButtonClick,
            handleOpenPopUp,
            handleSwitchFilter,
            sliderRef,
            isChangeFilter,
            isLoadMoreCases,
            sliderWrapperRef,
        } = this.props;

        return (
            <Root className={className} backgroundColor="#FFFFFF">
                <AnimationContainer external="parent">
                    <Title ref={sliderWrapperRef}>
                        Что мы
                        <Br760 />
                        {' '}
                        сделали
                    </Title>
                </AnimationContainer>
                <AnimationContainer external="parent" delay={150}>
                    <StyledFilters
                        filters={filters}
                        handleSwitchFilter={handleSwitchFilter}
                        sliderRef={sliderRef}
                    />
                </AnimationContainer>
                <AnimationContainer
                    withoutMountAndLocationUpdate
                    fade={isChangeFilter ? 'fadeOut' : 'fadeIn'}
                >
                    <CasesContainer>
                        {
                            decisions.map(({ ...caseData }) => {
                                const { hasTemplate } = caseData;
                                if (hasTemplate) {
                                    return (
                                        <CaseWithResize
                                            key={caseData.uuid}
                                            caseData={caseData}
                                            handleOpen={this.handleOpenFullSizeImages}
                                            handleOpenPopUp={handleOpenPopUp}
                                        />
                                    );
                                }
                                return (
                                    <CaseWithSlider
                                        handleOpen={this.handleOpenFullSizeImages}
                                        key={caseData.uuid}
                                        caseData={caseData}
                                    />
                                );
                            })
                        }
                    </CasesContainer>
                </AnimationContainer>
                {
                    decisions.length > 0 && (
                        <AnimationContainer
                            external="neighbour"
                            fade={isChangeFilter || isLoadMoreCases ? 'fadeOut' : 'fadeIn'}
                        >
                            <ButtonContainer>
                                <StyledButton
                                    onClick={onMoreDownloadButtonClick}
                                    moreDownloadNum={moreDownloadNum}
                                >
                                    {
                                        `загрузить ещё ${moreDownloadNum}`
                                    }
                                </StyledButton>
                            </ButtonContainer>
                        </AnimationContainer>
                    )
                }
            </Root>
        );
    }
}

const StyledButton = styled(BorderButton)`
    display: ${({ moreDownloadNum }) => (moreDownloadNum === 0 ? 'none' : '')};
    margin-top: 40px;
    width: 328px;
    height: 63px;

    ${mediaWidth.m} {
        margin-top: 56px;
        width: 266px;
    };

    ${mediaWidth.l} {
        margin-top: 40px;
        width: 282px;
    };

    ${mediaWidth.xl} {
        margin-top: 44px;
        width: 406px;
        height: 71px;
    };
`;

const CasesContainer = styled.div`
    margin-top: 32px;
    display: flex;
    flex-wrap: wrap;

    >div:nth-child(n+2) {
        margin-top: 40px;
    };

    ${mediaWidth.m} {
        margin-top: 48px;
        display: grid;
        grid-template-columns: 1fr 1fr;

        >div:nth-child(n+2) {
            margin-top: 0px;
        };
    };

    ${mediaWidth.l} {
        margin-top: 40px;
        grid-template-columns: 1fr 1fr 1fr;
    };

    ${mediaWidth.xl} {
        margin-top: 48px;
        grid-template-columns: 1fr 1fr 1fr;
    };
`;

const StyledFilters = styled(Filters)`
    margin-top: 32px;
`;

const Title = styled.div`
    ${Font.HEADLINE};
    font-size: 32px;
    line-height: 32px;

    text-transform: uppercase;

    color: ${color.TEXT_PRIMARY};

    ${mediaWidth.m} {
        font-size: 48px;
        line-height: 48px;
    }

    ${mediaWidth.l} {
        font-size: 32px;
        line-height: 32px;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
`;

const Root = styled(Content)``;

const Br760 = styled.br`
    display: block;

    ${mediaWidth.l} {
        display: none;
    }
`;
